import styled from 'styled-components';

import {
    sizeLaptopMd,
    sizeTabletLg,
    sizeLaptop,
    sizeMobileLg
} from "components/devices";

export const BlogSliderWrap = styled.div`
    margin: 20px 0 20px 0;
    overflow: hidden;
    width: 100%;
    position: relative;
    
    .slick-slider {
        overflow: hidden;
        padding: 0 0 80px 0px;
        ${sizeLaptop(`
            padding: 0 0 60px 15px;
        `)}
    }
    
    .slick-list {
        overflow: visible;
        padding: 0;
    }
    
    .slick-prev, 
    .slick-next {
        position: absolute;
        top: 50%;
        transform: translateY(-200%);
        width: 60px;
        height: 60px;
        border-radius: 50%;
        font-size: 0;
        z-index: 22;
        opacity: 1;
        transition: all 0.3s ease;
        ${sizeLaptop(`
            width: 50px;
            height: 50px;
        `)}
        ${sizeMobileLg(`
            width: 40px;
            height: 40px;
        `)}
        
        &:before {
            content: "";
            background: url("/images/next-arrow.svg") center center no-repeat;
            background-size: 60%;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            margin: 0;
            padding: 0;
            opacity: 1;
            transition: all 0.3s ease;
        }
        
        &:hover {
            transform: translateY(-200%) scale(1.1);
            &:before {
                // background-image: url("/images/next-arrow.svg");
                // filter: brightness(0) invert(1);
            }
        }
    }
    
    .slick-prev {
        left: 20px;
        ${sizeLaptop(`
            left: 15px;
        `)}
        ${sizeMobileLg(`
           left: 10px; 
        `)}
        
        &:before {
            background: url("/images/prev-arrow-purple.svg") center center no-repeat;
            background-size: 60%;
        }
        
        &:hover {
            &:before {
                // background-image: url("/images/prev-arrow-purple.svg");
                // filter: brightness(0) invert(1);
            }
        }

        &.slick-disabled {
            opacity: 0.5;
            border-color: #ccc;
            transition: all 0.3s ease;
            &:before {
                // background: url("/images/prev-arrow.svg") center center no-repeat !important;
                // background-size: 60%;
            }
        }
    }
    
    .slick-next {
        right: 20px;
        ${sizeLaptop(`
            right: 15px;
        `)}
        ${sizeMobileLg(`
           right: 10px; 
        `)}
        
        &.slick-disabled {
            opacity: 0.5;
            border-color: #ccc;
            transition: all 0.3s ease;
            &:before {
                // background: url("/images/prev-arrow.svg") center center no-repeat !important;
                // background-size: 60%;
                // transform: rotate(180deg);
            }
        }
    }
    
    .slick-dots {
        bottom: -40px;
        ${sizeMobileLg(`
            bottom: -30px;
        `)}
        
        li {
            margin: 0 5px;
            transition: all 0.3s ease;
            
            button:before {
                font-size: 12px;
                color: #D12FFF;
                opacity: 0.3;
                transition: all 0.3s ease;
            }
            
            &.slick-active button:before {
                opacity: 1;
                color: #D12FFF;
                transform: scale(1.2);
            }
            
            &:hover button:before {
                opacity: 0.7;
                transform: scale(1.1);
            }
        }
    }
`;

export const BlogSlide = styled.div`

`;
export const SlideImage = styled.img`
    width: calc(100% - 15px);
    object-fit: cover;
    height: 650px;
    ${sizeLaptopMd(`
        height: 500px;
    `)}
    ${sizeTabletLg(`
        height: 380px;
    `)}
`;